/* src/app/modules/portal/components/portal/portal.component.css */
:host {
  min-height: 100%;
  display: flex;
  flex-direction: column;
}
#portalLeftPane {
  height: 100%;
  margin: -20px;
  position: absolute;
  padding-top: 16px;
  padding-left: 16px;
}
.modals {
  margin: 0;
}
#portal-right-pane {
  grid-area: 1 / 12 / span 12 / span 1;
  width: fit-content;
  justify-self: end;
  z-index: 1;
}
.portal {
  margin: 0 0 2em 0;
  list-style-type: none;
  padding: 0;
  width: 15em;
}
.portal li {
  position: relative;
  cursor: pointer;
  width: 500px;
  background-color: #eee;
  margin: 0.5em;
  padding: 0.3em 3em;
  height: 1.6em;
  border-radius: 4px;
}
.portal li:hover {
  color: #607d8b;
  background-color: #ddd;
  left: 0.1em;
}
.portal a {
  color: #333;
  text-decoration: none;
  position: relative;
  display: block;
  width: 500px;
}
.portal a:hover {
  color: #607d8b;
}
.portal .badge {
  color: white;
  padding: 0.8em 0.7em 0 0.7em;
  background-color: #405061;
  line-height: 1em;
  position: relative;
  height: 1.8em;
  min-width: 16px;
  text-align: right;
  font-size: 8pt;
  margin-right: 0.8em;
  border-radius: 4px 0 0 4px;
}
.portal .fields {
  color: #405061;
  background-color: white;
  line-height: 1em;
  padding: 0.8em 0.7em 0 0.7em;
  text-align: right;
  font-size: 8pt;
  margin-right: 0.8em;
  border-radius: 0px 0 0 0px;
}
button {
  background-color: #eee;
  border: none;
  padding: 5px 10px;
  border-radius: 4px;
  cursor: hand;
  font-family: Arial, monospace;
}
button:hover {
  background-color: #cfd8dc;
}
button.delete {
  position: relative;
  left: 194px;
  top: -32px;
  background-color: gray !important;
  color: white;
}
.planes {
  min-height: 200px;
}
.divRow {
  display: table-row;
  width: auto;
  height: 100%;
}
.divCell {
  float: left;
  display: table-column;
  height: 100%;
}
#grid-portal {
  display: grid;
  height: 100%;
  grid-template-columns: repeat(12, 1fr);
  grid-template-rows: repeat(12, 1fr);
}
#empty-state-container {
  grid-area: 1 / 1 / span 12 / span 12;
}
#system-overview-container {
  grid-area: 1 / 1 / span 12 / span 11;
  padding: 16px;
}
/*# sourceMappingURL=portal.component.css.map */
